import React, { useEffect, useState } from "react";
import { Car } from "../Types/Car";
import CarCard from "../Cars/CarCard";
import "./CarViewer.css";
import axios from "axios";
import { apiBaseUrl } from "../../constants/config";
import { useNavigate } from "react-router";
interface CarViewerProps {
  isLoading: boolean;
}
const CarViewer: React.FC<CarViewerProps> = ({ isLoading }) => {
  const navigate = useNavigate();
  const [cars, setCars] = useState<Car[]>([]);
  const [loadingCars, setLoadingCars] = useState<boolean>(false);
  useEffect(() => {
    getCars();
  }, []);

  const getCars = async () => {
    setLoadingCars(true);
    try {
      const response = await axios.get(`${apiBaseUrl}/car-stock`);
      const slicedCars = response.data;
      setCars(slicedCars);
    } catch (error) {
      console.error("Error fetching cars", error);
    } finally {
      setLoadingCars(false);
    }
  };

  if (loadingCars) {
    return (
      <div className="car-container loading-container radius">
        <div className="loading"></div>
      </div>
    );
  }

  if (cars.length === 0) {
    return null;
  }

  return (
    <div className="car-container">
      <div className="car-container-header">Uusimmat vaihtoautot</div>
      <div className="car-viewer-list">
        {cars.map((car) => (
          <CarCard key={car.ID} car={car} />
        ))}
      </div>
      <div onClick={() => navigate("/cars")} className="view-more-button">
        Selaa lisää vaihtoautoja
      </div>
    </div>
  );
};
export default CarViewer;
